import Lottie from 'lottie-react';
import React from 'react';
// O JSON de Lottie foi renomeado para _surfing.json para ficar oculto. Não o importamos por padrão.
import surfingGif from '../../assets/animations/surfing.gif';
import { ContainerLoading } from './styles';

interface LoadingProps {
    backgroundWhite?: boolean;
    animation?: Record<string, unknown> | string; // aceita Lottie JSON (objeto) ou caminho para GIF (string)
}

export const Loading: React.FC<LoadingProps> = ({ backgroundWhite, animation }) => {
    // Prioriza prop `animation` (objeto Lottie ou URL de GIF). Por padrão usa o GIF.
    const anim: Record<string, unknown> | string = animation ?? surfingGif;
    const isGif = typeof anim === 'string';

    return (
        <ContainerLoading backgroundWhite={!!backgroundWhite}>
            <div>
                {isGif ? (
                    <img src={anim as string} alt="Loading" loading="lazy" style={{ maxWidth: '100%', height: 'auto' }} />
                ) : (
                    <Lottie animationData={anim as Record<string, unknown>} />
                )}
            </div>
        </ContainerLoading>
    );
};
